import { network } from 'services/network';

import { QueryParams } from 'api/queries/getMilestones.query';

export const getMilestone = (params: QueryParams) => {
    return network.post('api/bo/getMilestone', params).then((response) => {
        return response.data;
    });
};
